<template>
    <section>
        <Header />
        <div class="task-single">
            <div class="container">
                <div class="col-sm-3">
                    <div class="box box-priority" style="padding: 20px; text-align: center; margin-bottom: 20px;">
                        <b-button type="is-default" @click="goBack()">
                            <i class="fas fa-angle-left"></i> Go back
                        </b-button>
                    </div>
                    <div class="box box-priority" style="padding: 35px 20px 20px 20px; text-align: center; margin-bottom: 25px;">
                        <p style="text-transform: uppercase; font-weight: 800; margin-bottom: 8px;">Priority</p>
                        <template v-if="task">
                            <ul>
                                <li>
                                    <b-radio-button v-model="task.priority"
                                            :native-value="2"
                                            type="is-danger" class="text-center">
                                            High
                                        </b-radio-button>
                                    </li>
                                    <li>
                                    <b-radio-button v-model="task.priority"
                                            :native-value="1"
                                            type="is-warning" class="text-center">
                                            Medium
                                        </b-radio-button>
                                    </li>
                                    <li>
                                    <b-radio-button v-model="task.priority"
                                            :native-value="0"
                                            type="is-low" class="text-center">
                                            Low
                                        </b-radio-button>
                                    </li>
                            </ul>
                        </template>
                        <p style="text-transform: uppercase; font-weight: 800; margin-bottom: 8px; margin-top: 25px;">Status</p>
                        <template v-if="task">
                            <ul class="second-list">
                                <li>
                                    <b-radio-button v-model="task.status"
                                            :native-value="2"
                                            type="is-success" class="text-center">
                                            Completed
                                        </b-radio-button>
                                    </li>
                                    <li>
                                    <b-radio-button v-model="task.status"
                                            :native-value="1"
                                            type="is-primary" class="text-center">
                                            Started
                                        </b-radio-button>
                                    </li>
                                    <li>
                                    <b-radio-button v-model="task.status"
                                            :native-value="0"
                                            type="is-pending" class="text-center">
                                            Pending
                                        </b-radio-button>
                                    </li>
                            </ul>
                        </template>
                    </div>
                </div>
                <div class="col-sm-9">
                    <div class="box">
                        <p style="text-align: left; font-weight: 200; color: #888; font-size: 11px; font-style: italic;">
                            {{task.reporter.first_name}} {{task.reporter.last_name}} reported {{task.created | moment("from", true)}} ago
                        </p>
                        <h4>{{task.name}}</h4>
                        <span v-html="task.content"></span>
                    </div>
                    <div class="comments-box" style="overflow: hidden;">
                        <div class="comment box" v-for="comment in task_comments" :key="comment.id" style="overflow: hidden;">
                            <span style="font-weight: 800; float: left;">
                                {{comment.user.first_name}} {{comment.user.last_name}}
                                <span v-if="comment.status_comment" style="font-size: 11px; font-weight: 400; font-style: italic; margin-left: 8px;">
                                    updated status: {{translateTaskStatus(comment.status_to)}}
                                </span>
                            </span>
                            <span style="float: right; font-style: italic; font-size: 11px;">{{comment.created | moment("from", true)}}</span>
                            <div class="comment-content" v-if="!comment.status_comment">
                                <span v-html="comment.content"></span>
                            </div>
                        </div>
                    </div>

                    <div class="box" style="overflow: hidden; margin-top: 20px;">
                        <p style="text-transform: uppercase; font-weight: 800; margin-bottom: 20px;">Comment</p>
                        <WYSIWYG v-model="comment" :key="commentKey"/>
                        <b-button v-if="!commenting" @click="addComment()" type="is-primary" style="float: right; margin-top: 20px;">Submit</b-button>
                        <b-button v-else type="is-primary" style="float: right; margin-top: 20px;" loading>Submit</b-button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {getJWT, getHeaders, isEmptyDictionary} from '../logic/global'
import WYSIWYG from "../components/WYSIWYG";
import {getTask, getTaskComments, updateTask, createTaskComment, translateTaskStatus} from "../logic/task"
import Header from '../components/Header'


let task = {
    reporter: {

    }
};
let task_comments = []
let comment = ""
let commenting = false
let commentKey = 1

export default {
    name: 'TaskSingle',
    computed: mapGetters(["getWorkspaceId"]),
    components: {WYSIWYG, Header},
    data() {
        return {
            radioButton: null,
            radioButtonStatus: null,
            product_carousel: [],
            product_loop: [],
            comment: comment,
            task: task,
            task_comments: task_comments,
            commenting: commenting,
            commentKey: commentKey,
        }
    },
    watch: {
        'task': {
            handler: function (val, oldVal) {
                if(!isEmptyDictionary(oldVal.reporter)){
                    let payload = {...val}
                    delete payload["workspace"]
                    delete payload["reporter"]
                    updateTask(this.$route.params.workspace_id, this.$route.params.task_id, payload).then(response => {
                        this.showSuccessMsg("Task updated successfully", "is-success")
                        this._getTaskComments()
                    }).catch(error => {
                        this.showSuccessMsg("Error updating the task", "is-danger")
                    })
                }
            },
            deep: true
        }
    },
    methods: {
        translateTaskStatus: translateTaskStatus,
        _getTask: function(){
            getTask(this.$route.params.workspace_id, this.$route.params.task_id).then(response => {
                this.task = response.data
            })
        },
        goBack: function(){
            this.$router.push({
                name: 'workspace_single',
                params: {
                    workspace_id: this.$route.params.workspace_id
                }
            })
        },
        showSuccessMsg: function(message, msg_type){
            this.$toast.open({message: message, type: msg_type})
        },
        _getTaskComments: function(){
            getTaskComments(this.$route.params.workspace_id, this.$route.params.task_id).then(response => {
                this.task_comments = response.data
            })
        },
        addComment: function(){
            this.commenting = true;
            if(this.comment == ""){
                this.showSuccessMsg("The comment can not be empty.", "is-danger")
            }else{
                createTaskComment(
                    this.$route.params.workspace_id,
                    this.$route.params.task_id,
                    {"content": this.comment}
                ).then(response => {
                    this.task_comments = response.data
                    this.comment = ""
                    this.commentKey += 1;
                    this.commenting = false;
                })
            }
        }
    },
    mounted: function(){
       this._getTask();
       this._getTaskComments();
    }
}
</script>

<style scoped>
    .comment.box{
        margin-bottom: 10px;
        padding: 20px 25px 15px 25px !important;
        font-size: 12px;
        margin-left: 0px;
        background: #e1ecf2 !important;
    }
    .comment-content{clear: both; padding: 12px 0px;}
    .box-priority ul li{display: block;}
    .box-priority .second-list li{display: block;}
    .task-single{padding-top: 50px; padding-bottom: 50px;}
    .task-single >>> .b-radio.radio{
        margin: 3px 0px;
        font-weight: 400;
        font-size: 14px;
    }
    .task-single .box{
        background: #fff;
        padding: 35px 35px 35px 35px;
        border: 1px solid #ebebeb;
    }
    .task-single h4{
        margin: 30px 0px 20px 0px;
    }
    .table > tbody > tr > td, 
    .table > tbody > tr > th, 
    .table > tfoot > tr > td, 
    .table > tfoot > tr > th, 
    .table > thead > tr > td, 
    .table > thead > tr > th {
        padding: 15px !important;
    }
    .table tr:hover td{
        background: #abd7f1;
        cursor: pointer;
    }
</style>
